export default __webpack_public_path__ + "assets/076c6c27810a65f9fbf8b2684fe94755.woff2";